export const APPS_FETCH_REQUESTED = 'APPS_FETCH_REQUESTED';
export const APPS_FETCH_SUCCEEDED = 'APPS_FETCH_SUCCEEDED';
export const APPS_FETCH_FAILED = 'APPS_FETCH_FAILED';
export const APP_ADD_REQUESTED = 'APP_ADD_REQUESTED';
export const APP_ADD_SUCCEEDED = 'APP_ADD_SUCCEEDED';
export const APP_ADD_FAILED = 'APP_ADD_FAILED';

export function fetchApps() {
  return {
    type: APPS_FETCH_REQUESTED
  };
}

export function createApp(app) {
  return {
    type: APP_ADD_REQUESTED,
    payload: { app }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/appActions.js